module.exports = __webpack_public_path__ + "static/media/kakao.e5acb777.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/assets/kakao.png
// module id = 828
// module chunks = 0